module.exports = __webpack_public_path__ + "img/edit-blue.7112a866.svg";